import useConfig from "@/config/useConfig";

export default defineNuxtRouteMiddleware((to) => {
  const config = useConfig();

  if (config.MAINTENANCE) {
    if (to.path !== "/maintenance") {
      return navigateTo("/maintenance");
    }
  } else {
    if (to.path === "/maintenance") {
      return navigateTo("/");
    }
  }
});
